import { render, staticRenderFns } from "./AbstractCulturalSensitivityWarning.vue?vue&type=template&id=0efcf748&"
import script from "./AbstractCulturalSensitivityWarning.vue?vue&type=script&lang=js&"
export * from "./AbstractCulturalSensitivityWarning.vue?vue&type=script&lang=js&"
import style0 from "./AbstractCulturalSensitivityWarning.vue?vue&type=style&index=0&id=0efcf748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports